import axios from "axios";

export default {
    state: {
        accountantTerminals: null,
    },
    getters: {
        getAccountantTerminals(state) {
            return state.accountantTerminals
        },
    },
    mutations: {
        setAccountantTerminals(state, data) {
            return state.accountantTerminals = data
        },
    },
    actions: {
        accountantTerminalsRequest(context) {
            return axios.get('/api/accountant/terminals')
                .then(res => {
                    context.commit('setAccountantTerminals', res.data)
                })
        },
    }
}